export const comparePropertiesBetweenObjects = <Obj1 = object, Obj2 = object>(
  obj1: Obj1,
  obj2: Obj2,
  keys: (keyof Obj1 & keyof Obj2)[]
): boolean =>
  keys
    .map(key => String(obj1[key]) === String(obj2[key]))
    .every(value => value);

export function removeFalsyValues(
  object: Record<string, Nullable<unknown | Falsy>>
) {
  return Object.keys(object).reduce(
    (acc, currentKey) =>
      object[currentKey] ? { ...acc, [currentKey]: object[currentKey] } : acc,
    {}
  );
}

export const getKeys: <T extends ObjectLiteral>(o: T) => (keyof T)[] =
  Object.keys;

export const getValues: <T extends ObjectLiteral>(o: T) => T[keyof T][] =
  Object.values;
